function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    strokeWidth: 1.5,
    color: "#000",
    role: "presentation"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.77 8.18V22.5H3.41V5.32h13.36z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.77 18.68h3.82V1.5H7.23v3.82",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: 10
    }
  }));
};
export default SvgCopy;